var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileExcel(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 7.1001C13.7 6.82396 13.8492 6.6001 14.0333 6.6001H15.3667C15.5508 6.6001 15.7 6.82396 15.7 7.1001C15.7 7.37624 15.5508 7.6001 15.3667 7.6001H14.0333C13.8492 7.6001 13.7 7.37624 13.7 7.1001Z",
    fill: "#46A98B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0333 8.6001C13.8492 8.6001 13.7 8.82396 13.7 9.1001C13.7 9.37624 13.8492 9.6001 14.0333 9.6001H15.3667C15.5508 9.6001 15.7 9.37624 15.7 9.1001C15.7 8.82396 15.5508 8.6001 15.3667 8.6001H14.0333Z",
    fill: "#46A98B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 11.1001C13.7 10.824 13.8492 10.6001 14.0333 10.6001H15.3667C15.5508 10.6001 15.7 10.824 15.7 11.1001C15.7 11.3762 15.5508 11.6001 15.3667 11.6001H14.0333C13.8492 11.6001 13.7 11.3762 13.7 11.1001Z",
    fill: "#46A98B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0333 12.6001C13.8492 12.6001 13.7 12.824 13.7 13.1001C13.7 13.3762 13.8492 13.6001 14.0333 13.6001H15.3667C15.5508 13.6001 15.7 13.3762 15.7 13.1001C15.7 12.824 15.5508 12.6001 15.3667 12.6001H14.0333Z",
    fill: "#46A98B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3.73525C13 2.66324 11.9827 1.84779 10.8653 2.02403L3.53194 3.18058C2.64792 3.32 2 4.04376 2 4.89181V15.1082C2 15.9562 2.64792 16.68 3.53194 16.8194L10.8653 17.976C11.9635 18.1492 12.965 17.3645 12.9991 16.3198H16.25C17.2165 16.3198 18 15.5363 18 14.5698V5.56982C18 4.60333 17.2165 3.81982 16.25 3.81982H13V3.73525ZM13 5.31982V14.8198H16.25C16.3881 14.8198 16.5 14.7079 16.5 14.5698V5.56982C16.5 5.43175 16.3881 5.31982 16.25 5.31982H13Z",
    fill: "#46A98B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55004 7.15004C5.88141 6.90152 6.35152 6.96867 6.60004 7.30004L7.50004 8.50004L8.40004 7.30004C8.64857 6.96867 9.11867 6.90152 9.45004 7.15004C9.78141 7.39857 9.84857 7.86867 9.60004 8.20004L8.43754 9.75004L9.60004 11.3C9.84857 11.6314 9.78141 12.1015 9.45004 12.35C9.11867 12.5986 8.64857 12.5314 8.40004 12.2L7.50004 11L6.60004 12.2C6.35152 12.5314 5.88141 12.5986 5.55004 12.35C5.21867 12.1015 5.15152 11.6314 5.40004 11.3L6.56254 9.75004L5.40004 8.20004C5.15152 7.86867 5.21867 7.39857 5.55004 7.15004Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExcel);
export default __webpack_public_path__ + "static/media/file-excel.932c6887.svg";
export { ForwardRef as ReactComponent };